import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";
import {
  createStore,
  deleteStore,
  setError,
  setLoading,
  setStorDetail,
  setStoreById,
  setStores,
  updateStore,
  updateStoreStatus,
} from "../../Reducer/Store/StoreSlice";
import { setActiveForm } from "../../Reducer/Admin/PartnerSlice";
import toast from "react-hot-toast";

export const getStoreDetails = createAsyncThunk(
  "store/getStoreDetails",
  async (token, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/store/get-store-detail");
      dispatch(setStorDetail(response.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const fetchStores = createAsyncThunk(
  "store/fetchStores",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/store/all");
      dispatch(setStores(response.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const fetchStoreById = createAsyncThunk(
  "store/fetchStoreById",
  async ({ storeId }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`api/store/${storeId}`);
      dispatch(setStoreById(response.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
      // toast.error("Something went wrong!");
    }
  }
);

export const modifyStore = createAsyncThunk(
  "store/modifyStore",
  async ({ storeId, updatedData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.put(`api/store/${storeId}`, updatedData);
      if (response.status === 200) {
        // toast.success("Store updated successfully");
        dispatch(updateStore({ storeId, updatedData: response.data }));
        // dispatch(setStoreById({}));
        dispatch(fetchStores());
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      // toast.error(error.message);
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const addStore = createAsyncThunk(
  "store/addStore",
  async (store, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/store/create`, store);
      if (response.status === 200 || response.status === 201) {
        dispatch(createStore(response.data));
        dispatch(setActiveForm(null));
        toast.success("Store created successfully");
        dispatch(setLoading(false));
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const removeStore = createAsyncThunk(
  "doctor/removeStore",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(`api/store/${id}`);
      if (response.status === 200) {
        dispatch(deleteStore(id));
        dispatch(setLoading(false));
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const integrateDoctor = createAsyncThunk(
  "doctor/IntegrateDoctorToStore",
  async (data, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/store/assign-doctors`, data);
      if (response.status === 200) {
        dispatch(setLoading(false));
        // dispatch(getAllDoctorsOfStore(data.SID))

        return response;
      }
      // dispatch(deleteStore(id));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return rejectWithValue(
        error.response
          ? error.response.data
          : { message: "Unknown error occurred" }
      );
    }
  }
);

export const updateStatus = createAsyncThunk(
  "store/updateStatus",
  async (status, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(
        `api/store/update-store-status`,
        status
      );
      if (response.status === 200) {
        dispatch(updateStoreStatus({ newStatus: status.currentStoreStatus }));
        // dispatch(getStoreDetails());
        dispatch(setLoading(false));
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const cancelOrder = createAsyncThunk(
  "store/cancelOrder",
  async ({ OID, cancelledReason }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(
        `api/order/cancel/${OID}`,
        cancelledReason
      );
      if (response.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);
